import { useSelector } from 'react-redux';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { IDefaultPopup } from '@r1-frontend/ui-react/components/popups/defaultPopup';

import { LkPromotionalPopupExtra } from '~/src/features/specialOffersContainer/containers/popups/LkPromotionalPopupExtra';
import { TState } from '~/src/store';

export const PromoErrorPopup = (props: IDefaultPopup) => {
    const errorMessage = useSelector((state: TState) => state.specOffers.errorMessage);

    return <LkPromotionalPopupExtra
        message={errorMessage || 'Что-то пошло не так. Попробуйте ещё раз.'}
        positive={false}
        buttons={(onClose) => [
            <Button
                key={'btnClose'}
                onClick={onClose}
                bType={'secondary'}
                size={'large'}
                data-test={'LkPromotionalPopupExtra-btnclose'}
            >
                Закрыть
            </Button>,
        ]}
        {...props}
    />;
};
